export const generateQueryKey = () => 'id' + Math.random().toString(16).slice(2);
